import * as httpClient from '../utils/httpClient';

export const save = async (payload, requestContext) => {
  const body = payload;
  const path = '/questionnaire/save-answer';

  const apiClient = httpClient.getHttpClient(requestContext.headers);
  return apiClient
  .post(path, body)
  .then((res) => res.data)
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error('questionnaireRquest error', err);
  });
};
